/* SPOOKY CART — collection filtering & sorting without a full page reload */
(function () {
  'use strict';
  const S = window.Spooky || {};
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  let sectionId = null;
  let pending = null;

  function setLoading(on) {
    const grid = $('[data-product-grid]');
    if (grid) grid.classList.toggle('is-loading', on);
  }

  async function apply(url, pushState) {
    if (!sectionId) return;
    if (pending) pending.abort();
    pending = new AbortController();
    setLoading(true);
    try {
      const res = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + sectionId, {
        signal: pending.signal
      });
      if (!res.ok) throw new Error('filter failed');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      ['[data-facets-form]', '[data-product-grid-wrapper]', '[data-active-filters]', '[data-collection-count]', '[data-pagination]']
        .forEach((sel) => {
          const next = doc.querySelector(sel);
          $$(sel).forEach((current) => {
            if (next) current.innerHTML = next.innerHTML;
          });
        });

      if (pushState !== false) history.pushState({ facets: true }, '', url);
      bind();
      S.init && S.init(document);
      window.scrollTo({ top: ($('[data-collection-top]')?.offsetTop || 0) - 90, behavior: 'smooth' });
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = url;
    } finally {
      setLoading(false);
    }
  }

  function formUrl(form) {
    const params = new URLSearchParams(new FormData(form));
    // Strip empty values so the URL stays clean
    Array.from(params.keys()).forEach((k) => {
      if (!params.get(k)) params.delete(k);
    });
    const base = form.getAttribute('action') || window.location.pathname;
    const qs = params.toString();
    return base + (qs ? '?' + qs : '');
  }

  function bind() {
    const form = $('[data-facets-form]');
    if (form && !form.dataset.bound) {
      form.dataset.bound = '1';
      form.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"], input[type="radio"], select')) {
          apply(formUrl(form));
        }
      });
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        apply(formUrl(form));
      });
      // Debounced price inputs
      $$('input[type="number"], input[type="range"]', form).forEach((input) => {
        let t;
        input.addEventListener('input', () => {
          clearTimeout(t);
          t = setTimeout(() => apply(formUrl(form)), 550);
        });
      });
    }

    $$('[data-facet-remove]').forEach((link) => {
      if (link.dataset.bound) return;
      link.dataset.bound = '1';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        apply(link.getAttribute('href'));
      });
    });

    const sort = $('[data-sort-by]');
    if (sort && !sort.dataset.bound) {
      sort.dataset.bound = '1';
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        apply(url.pathname + url.search);
      });
    }

    $$('[data-pagination] a').forEach((link) => {
      if (link.dataset.bound) return;
      link.dataset.bound = '1';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        apply(link.getAttribute('href'));
      });
    });
  }

  window.addEventListener('popstate', () => apply(window.location.pathname + window.location.search, false));

  document.addEventListener('DOMContentLoaded', () => {
    const root = $('[data-facets-section]');
    if (!root) return;
    sectionId = root.getAttribute('data-facets-section');
    bind();
  });
})();
